import { NgModule, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';

// components
import { QuickQuoteComponent } from './quick-quote/quick-quote.component';

// services
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuoteService } from '../../../../../coverpath-common/angular/services/quote/quote.service';
import { QuickQuoteService } from '../../services/quote/quick-quote.service';
import { QuoteCardService } from '../home/quote-card/quote-card.service';

// modules
import { BaseFormModule } from '../../../../../coverpath-common/angular/components/form/base-form.module';
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../../../coverpath-common/angular/components/shared/spinner/spinner.module';
import { QuoteComponent } from './quote.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DesignSystemModule } from '@hit/coverpath-design-system';
import { FormBuilderService } from '../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/form-builder.service';
import { ValidatorsService } from '../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/validators.service';
import { AdvisorSelectionService } from '../../../../../coverpath-agent/public/js/services/advisor-selection/advisor-selection.service';
import { TotalPremiumService } from '../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/total-premium.service';
import { RecalculationService } from '../../../../../coverpath-agent/public/js/components/home-new/quote-or-apply-new/recalculation.service';

@NgModule({
  declarations: [QuickQuoteComponent, QuoteComponent],
  imports: [
    BaseFormModule,
    RouterModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
    CommonModule,
    FormsModule,
    DesignSystemModule,
  ],
  exports: [QuickQuoteComponent],
  providers: [
    AmorphicService,
    QuoteService,
    QuickQuoteService,
    QuoteCardService,
    FormBuilderService,
    ValidatorsService,
    AdvisorSelectionService,
    TotalPremiumService,
    RecalculationService,
  ],
  bootstrap: [QuickQuoteComponent],
})
export class QuoteModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    QuoteModule.injector = injector;
  }
}
